import type { AddressInfo } from "features/dt-basic-setup/single-building/model/types";

export const ADDRESS_DEBOUNCE_MS = 1000;
export const MIN_QUERY_LENGTH = 3;
export const MAP_MOVE_ANIMATION_DURATION_SECONDS = 0.85;

export const ADDRESS_FORM_FIELDS: {
  i18nKey: string;
  key: keyof AddressInfo;
  required?: boolean;
  xs: number;
}[] = [
  { i18nKey: "name", key: "name", required: true, xs: 12 },
  { i18nKey: "address", key: "address", required: true, xs: 12 },
  { i18nKey: "postal_code", key: "postal_code", required: true, xs: 6 },
  { i18nKey: "city", key: "city", required: true, xs: 6 },
  { i18nKey: "country", key: "country", required: true, xs: 6 },
];
